import styled from 'styled-components';

interface EmailProps {
  isEmailValid: boolean;
  disabled?: boolean;
}

export const EmailContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
EmailContainer.displayName = 'EmailContainer';

export const EmailLabel = styled.label<EmailProps>`
  width: 100%;
  margin-bottom: 6px;
  font-size: 3vw;
  ${({ isEmailValid }): string => {
    return isEmailValid
      ? ''
      : 'color: #F32020;';
  }}
`;
EmailLabel.displayName = 'EmailLabel';

export const EmailInput = styled.input<EmailProps>`
  font-size: 3vw;
  box-sizing: border-box;
  width: 100%;
  padding: 0 2vw;
  height: 7.7vh;
  border-radius: 4px;
  outline: none;
  border: 1px solid ${({ isEmailValid }): string => {
    return isEmailValid
      ? '#BBB'
      : '#F32020';
  }
};
  ${({ disabled }): string => {
    return disabled === true
      ? `
color: initial;
border: none;
background: inherit;
padding-left: unset;
font-weight: bolder;      
`
      : '';
  }
}
`;
EmailInput.displayName = 'EmailInput';
